import { put, takeLatest } from 'redux-saga/effects';
import { StoreActionProps } from 'data/core';
import { logger } from 'services';
import {
  AllocationBulkUpdatePayload,
  allocationsBulkAction,
  updateAllocatedMembersAction,
  UpdateAllocatedMembersPayload,
} from '../actions';
import { bulkActions, setAllocatedMembers } from '../slices';

function* allocationBulkAction(
  action: StoreActionProps<AllocationBulkUpdatePayload>,
) {
  try {
    const {
      payload: { actionsMap, relativeDate, isHoursPerWeek },
    } = action;

    yield put(bulkActions({ actionsMap, relativeDate, isHoursPerWeek }));
  } catch (error) {
    logger.error('an error on updating allocations', { error });
  }
}
export function* watchAllocationBulkActionSaga(): Generator {
  yield takeLatest(allocationsBulkAction.type, allocationBulkAction);
}

function* updateAllocatedMembers(
  action: StoreActionProps<UpdateAllocatedMembersPayload>,
) {
  try {
    const { payload } = action;

    yield put(setAllocatedMembers(payload));
  } catch (error) {
    logger.error('an error on updating allocated members', { error });
  }
}
export function* watchUpdateAllocatedMemberSaga(): Generator {
  yield takeLatest(updateAllocatedMembersAction.type, updateAllocatedMembers);
}
